query UsersQuery {
  users {
    username
    email
    firstName
    lastName
  }
}
